import { css } from 'aphrodite';
import * as React from 'react';
import { LoadingSpinner } from '../../../../web/components/LoadingSpinner';
import { CircularAddIcon } from '../../../../web/components/svgs/icons/CircularAddIcon';
import { baseStyleSheet } from '../../../../web/styles/styles';
import { styleSheet } from './styles';

export const IndustryTemplatesActionBarHeader: React.FC<React.PropsWithChildren> = ({ children }) => {
	return (
		<div className={css(styleSheet.section)}>
			<div className={css(styleSheet.sectionTitle)} />
			{children}
		</div>
	);
};

interface IIndustryTemplatesCreateButtonProps
	extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
	isLoading?: boolean;
}

export const IndustryTemplatesCreateButton: React.FC<IIndustryTemplatesCreateButtonProps> = props => {
	const { isLoading, ...restProps } = props;
	return (
		<button {...restProps} className={`${props.className || ''} ${css(styleSheet.newButton)}`}>
			<CircularAddIcon className={css(styleSheet.newButtonIcon)} />
			Create New
			<br />
			{restProps.children}
			{!!isLoading && <LoadingSpinner className={css(baseStyleSheet.absoluteCenter)} />}
		</button>
	);
};
